import React from 'react';

export function StepOtherInformationLabel() {
  return <>Ostatní informace</>;
}
